// /components/image/ImageManagerProvider.tsx
'use client'

import React, { createContext, useContext, useMemo, useState } from 'react'
import { ImageManager } from '@/components/image/ImageManager'

type Ctx = {
  openImageManager: (opts: { sellerId: number; onSelect: (img: { url: string }) => void }) => void
}

const ImageManagerCtx = createContext<Ctx | null>(null)

export function ImageManagerProvider({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false)
  const [sellerId, setSellerId] = useState<number | null>(null)
  const [onSelect, setOnSelect] = useState<((img: { url: string }) => void) | null>(null)

  const api = useMemo<Ctx>(() => ({
    openImageManager: ({ sellerId, onSelect }) => {
      setSellerId(sellerId)
      setOnSelect(() => onSelect)
      setOpen(true)
    },
  }), [])

  return (
    <ImageManagerCtx.Provider value={api}>
      {children}

      {/* ✅ un solo modal global */}
      {sellerId != null && (
        <ImageManager
          open={open}
          onClose={() => setOpen(false)}
          onSelect={(img) => {
            onSelect?.(img)
            setOpen(false)
          }}
          sellerId={sellerId}
        />
      )}
    </ImageManagerCtx.Provider>
  )
}

export function useImageManager() {
  const ctx = useContext(ImageManagerCtx)
  if (!ctx) throw new Error('useImageManager must be used within ImageManagerProvider')
  return ctx
}
